import Dashboard from "./components/Dashboard/Dashboard";
import Projects from "./components/Projects/Projects";
import Layout from "./pages/Layout";
import Chat from "./components/Chat/Chat";
import AnalysisPage from "./pages/AnalysisPage";
import Profile from "./components/Profile/Profile";
import store from "./store";
import { BrowserRouter,Route,Routes  } from "react-router-dom";
import { Provider } from "react-redux";

function App() {
  return (
	  <Provider store={store}>
    			<div className="app">
					 <div className="wrapper">
	 					 <BrowserRouter>
						  <Routes>
								<Route path="/admin-dashboard" element={<Layout/>}>
									<Route index path="/admin-dashboard" element={<Dashboard/>}/>
									<Route  path="/admin-dashboard/chat" element={<Chat/>}/>
									<Route  path="/admin-dashboard/profile" element={<Profile/>}/>
									<Route  path="/admin-dashboard/projects" element={<Projects/>}/>
								</Route>							  
									<Route  path="/admin-dashboard/analysis" element={<AnalysisPage/>}/>
							</Routes>	
	 					</BrowserRouter>
					 </div>
    			</div>
	 </Provider>
  );
}

export default App;
